import logoBase64 from "@/pages/goodsOrder/logoBase64.js";
import jsonOperator from "@/components/json_demo.js";

/** 鉴别报告标签打印（WebSocket 连接本地 ZMIN 打印服务） */
export default {
  data() {
    return {
      printSocket: null,
      printMessage: "",
      printResultMessage: null,
      printIndex: 0,
      printNum: 0,
      totalNum: 0,
      darkness: 15,
      printSpeed: 4,
      printError: false,
      printJson: {
        Printer: {
          printername: "ZMIN X1i",
          printerinterface: "USB",
          printerdpi: "300",
          printSpeed: "4",
          printDarkness: "15",
        },
        LabelFormat: {
          labelwidth: "60",
          labelheight: "15",
          labelrowgap: "3",
        },
        LabelObjectList: [],
        Operate: "print",
      },
      currentPrintRow: null,
      printDialogVisible: false,
      _resolveReportPrintData: null,
    };
  },
  methods: {
    handleClosePrintDialog() {
      this.printDialogVisible = false;
      this.printResultMessage = null;
    },

    /**
     * @param {object} row 当前行数据
     * @param {(row: object) => { var7: string, var8: string }} resolvePrintData
     */
    startReportLabelPrint(row, resolvePrintData) {
      this._resolveReportPrintData = resolvePrintData;
      this.printIndex = 0;
      this.totalNum = 1;
      this.printJson.Printer.printSpeed = this.printSpeed;
      this.printJson.Printer.printDarkness = this.darkness;
      this.currentPrintRow = row;

      if (!this.printSocket || this.printSocket.readyState !== WebSocket.OPEN) {
        this.initReportPrintSocket();
      } else {
        this.printSocket.send("ZM_GetPrinterStatus_USB|500");
      }
    },

    initReportPrintSocket() {
      this.printSocket = new WebSocket("ws://127.0.0.1:1808");

      this.printSocket.onopen = () => {
        this.printSocket.send("ZM_GetPrinterStatus_USB|500");
      };

      this.printSocket.onmessage = (event) => {
        this.printMessage = event.data;

        if (this.printMessage.indexOf("PrinterStatus_USB:") === 0) {
          const status = parseInt(
            this.printMessage.replace("PrinterStatus_USB:", ""),
            10
          );
          if (status !== 0) {
            this.printResultMessage = jsonOperator.getStatusMessage(status);
            this.printDialogVisible = true;
            if (
              !this.printError &&
              (this.printNum !== 0 || this.printNum > this.totalNum)
            ) {
              this.printError = true;
              this.printNum--;
            }
          } else {
            this.printError = false;
            if (this.printNum < this.totalNum) {
              this.printJson.Operate = "print";
              const row = this.currentPrintRow;
              const resolver = this._resolveReportPrintData;
              const extra =
                typeof resolver === "function" ? resolver(row) : {};
              const printData = {
                var1: "香味研究所",
                var2: logoBase64,
                var3: "撕",
                var4: "毁",
                var5: "无",
                var6: "效",
                var7: extra.var7 || "",
                var8: extra.var8 || "",
              };

              this.printJson.LabelObjectList =
                jsonOperator.getLabelObjectListByQRCodev2Job(printData);
              this.printSocket.send(JSON.stringify(this.printJson, null, 2));
              this.printNum++;
            } else {
              this.printResultMessage =
                "打印结束,共打印" + this.printNum + "张";
              this.printDialogVisible = true;
              this.printNum = 0;
              this.totalNum = 0;
              this.currentPrintRow = null;
              this._resolveReportPrintData = null;
            }
          }
        }

        if (this.printMessage.indexOf("打印完成") === 0) {
          setTimeout(() => {
            this.printSocket.send("ZM_GetPrinterStatus_USB|500");
            this.printResultMessage = "打印第" + this.printNum + "张完成";
            this.printDialogVisible = true;
          }, 1300);
        }
      };

      this.printSocket.onerror = () => {
        this.printResultMessage = "打印机连接失败，请检查打印服务是否启动";
        this.printDialogVisible = true;
        this._resolveReportPrintData = null;
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/reportLabelPrintMixin.js